import React, { useState } from "react";
import ModalCenter from "../../../../../components/common/Modal/ModalCenter";
import Button from "../../../../../components/common/buttons/Button";
import InputTextSimple from "../../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonFluid from "../../../../../components/common/buttons/ButtonFluid";
import ButtonOutlineFluid from "../../../../../components/common/buttons/ButtonOutlineFluid";
import ButtonOutlineWithIcon from "../../../../../components/common/buttons/ButtonOutlineWithIcon";
import PlusIcon from ".//..//..//..//..//..//assets//images//icons//plus.svg";
import GmapPlaceSearchBox from "../../../../../components/calculator/GmapPlaceSearch/GmapPlaceSearchBox";
import HttpHelper from "../../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../../constants/API_ROUTES";
import useAuth from "../../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../constants/Routes";

const StartLocationCreate = ({ pushStartLocation }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const navigate = useNavigate();
  const { getAuth, clearAuth } = useAuth();
  const [startLocation, setStartLocation] = useState("");
  const [locationState, setLocationState] = useState("");
  const searchChange = (e) => {
    console.log(e);
  };
  const updateDestination = (
    streetNumber,
    route,
    country,
    locality,
    postalCode,
    placeId,
    name,
    address,
    lat,
    lng,
    index
  ) => {
    setLocationState({
      streetNumber,
      route,
      country,
      locality,
      postalCode,
      placeId,
      name,
      address,
      lat,
      lng,
      index,
    });
  };
  const createStartLocation = () => {
    console.log(locationState);

    HttpHelper.PostRequest({
      route: API_ROUTES.START_LOCATION_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        streetNumber: locationState?.streetNumber,
        route: locationState?.route,
        country: locationState?.country,
        locality: locationState?.locality,
        postalCode: locationState?.postalCode,
        place_id: locationState?.placeId,
        helyszin_neve: locationState?.name,
        cim: locationState?.address,
        latitude: locationState?.lat,
        longitute: locationState?.lng,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          const startLocation = res?.data?.startLocation;
          pushStartLocation(startLocation);
          closeModal();
          toast.success(res?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 422) {
          toast.error("Kérjük, válasszon először egy helyet", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 500) {
          toast.error(res?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else {
          toast.error("Hiba, a kezdőhely nem lett létrehozva.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        toast.error("Hiba, a kezdőhely nem lett létrehozva.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <ButtonOutlineWithIcon label={"Kezdőhely hozzáadása."} icon={PlusIcon} onClick={openModal} />
      <ModalCenter isOpen={isOpen} closeModal={closeModal} header="Új tétel hozzáadása">
        <div className="w-full">
          <GmapPlaceSearchBox
            label={`Indulási cím`}
            index={0}
            value={startLocation?.address}
            onChange={(e) => searchChange(e.target.value, 0)}
            updateDestination={updateDestination}
          />
        </div>

        <div className="mt-12 ps-[230px] gap-5 flex flex-row  text-center">
          <ButtonOutlineFluid label={`Mégsem`} onClick={closeModal} />
          <ButtonFluid label={`Mentés`} onClick={createStartLocation} />
        </div>
      </ModalCenter>
    </>
  );
};

export default StartLocationCreate;
